enum Popups {
  error = 'error',
}

export default {
  [Popups.error]: {
    component: 'ErrorPopup',
    props: { transition: { name: 'slide-top' } },
  },
};
